import {
  ICON_NAME_ARTIST, ICON_NAME_NEWS, ICON_NAME_FANBOX, ICON_NAME_CLUB,
  ICON_NAME_PROMOTION, ICON_NAME_TEAM, ICON_NAME_EVENTS, ICON_NAME_OPPONENTS, ICON_NAME_SETTINGS, ICON_NAME_MEMBERS,
  ICON_NAME_LEGAL, ICON_NAME_BANNER, ICON_NAME_SHOP, ICON_NAME_STREAM, ICON_NAME_PREMIUM_PARTNER, ICON_NAME_MAIN_MENU,
  ICON_NAME_VOTE, ICON_NAME_FORUM, ICON_NAME_FAN_FEED, ICON_NAME_WAY_FINDER, ICON_NAME_VIP, ICON_NAME_STUDIOS
} from '../../components/Icons/constants';
import {UserRole} from '../../types';
import Club from '../../api/club';
import config from 'config';
import { environment } from "./../../utilites/helpers";

interface ILiveSiteModuleConfig {
  type: string;
  name: string;
  icon: string;
  access: UserRole[];
  link: string;
  isOnMenu: boolean;
  isOnBannerTable: boolean;
  external?:boolean
}

interface ILiveSiteModuleConfigGroup {
  type: string;
  name: string;
  icon: string;
  access: UserRole[];
  children?: (ILiveSiteModuleConfig | ILiveSiteModuleConfigGroup)[];
  link: string;
  isOnMenu: boolean;
  isOnBannerTable: boolean;
}

export interface ILiveSiteClubConfig {
  club: Club;
  modules: (ILiveSiteModuleConfig | ILiveSiteModuleConfigGroup)[];
}

export class InfoCmsModuleConfig implements ILiveSiteModuleConfig {
  type:string;
  isOnMenu:boolean;
  isOnBannerTable:boolean;
  access: UserRole[];
  link: string;
  protected _addRichText: boolean = false;
  protected _addTwoColumn: boolean = false;
  protected _addPlayers: boolean = false;
  protected _addTransfers: boolean = false;

  constructor(public name: string, public icon: string) {
    this.access = ['EM'];
    this.link = '/info';
  }

  get addTransfers(): boolean {
    return this._addTransfers;
  }
  get addPlayers(): boolean {
    return this._addPlayers;
  }
  get addTwoColumn(): boolean {
    return this._addTwoColumn;
  }
  get addRichText(): boolean {
    return this._addRichText;
  }
}

export const LoginModuleConfig: ILiveSiteModuleConfig = {
  type: 'registration',
  name: 'Login Page',
  icon: ICON_NAME_PREMIUM_PARTNER,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const MenuModuleConfig: ILiveSiteModuleConfig = {
  type: 'main',
  name: 'Main Menu',
  icon: ICON_NAME_MAIN_MENU,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const AboutUsModuleConfig: ILiveSiteModuleConfig = {
  type: 'about_us',
  name: 'About Us',
  icon: ICON_NAME_CLUB,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: true,
  isOnBannerTable: true
};

export const ArtistModuleConfig: ILiveSiteModuleConfig = {
  type: 'about_us',
  name: 'Artist',
  icon: ICON_NAME_ARTIST,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: true,
  isOnBannerTable: true
};

export const StudiosModuleConfig: ILiveSiteModuleConfig = {
  type: 'about_us',
  name: 'Studios',
  icon: ICON_NAME_STUDIOS,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: true,
  isOnBannerTable: true
};

export const TeamModuleConfig: ILiveSiteModuleConfig = {
  type: 'players',
  name: 'Team',
  icon: ICON_NAME_TEAM,
  access: ['PM', 'EM'],
  link: '/players',
  isOnMenu: true,
  isOnBannerTable: false
};

export const AccountsManagementModuleConfig: ILiveSiteModuleConfig = {
  type: 'clubs',
  name: 'Accounts',
  icon: ICON_NAME_CLUB,
  access: ['PM'],
  link: '/clubs',
  isOnMenu: true,
  isOnBannerTable: false
};

export const NewsModuleConfig: ILiveSiteModuleConfig = {
  type: 'news',
  name: 'News',
  icon: ICON_NAME_NEWS,
  access: ['PM', 'EM'],
  link: '/news',
  isOnMenu: true,
  isOnBannerTable: true
};

export const FanBoxModuleConfig: ILiveSiteModuleConfig = {
  type: 'fan_box',
  name: 'Inbox',
  icon: ICON_NAME_FANBOX,
  access: ['PM', 'EM'],
  link: '/fanbox',
  isOnMenu: true,
  isOnBannerTable: true
};

export const EngageModuleConfig: ILiveSiteModuleConfig = {
  type: 'engage',
  name: 'Engage',
  icon: ICON_NAME_VOTE,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const ForumModuleConfig: ILiveSiteModuleConfig = {
  type: 'fan_pit',
  name: 'Forum',
  icon: ICON_NAME_FORUM,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const FanFeedModuleConfig: ILiveSiteModuleConfig = {
  type: 'fan_feed',
  name: 'Fan Feed',
  icon: ICON_NAME_FAN_FEED,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const MadeAndMetModuleConfig: ILiveSiteModuleConfig = {
  type: 'fan_feed',
  name: 'Made@Met',
  icon: ICON_NAME_FAN_FEED,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const WayFinderModuleConfig: ILiveSiteModuleConfig = {
  type: 'wayfinder',
  name: 'Way Finder',
  icon: ICON_NAME_WAY_FINDER,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const VipModuleConfig: ILiveSiteModuleConfig = {
  type: 'vip',
  name: 'VIP',
  icon: ICON_NAME_VIP,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: false,
  isOnBannerTable: true
};

export const PromotionsModuleConfig: ILiveSiteModuleConfig = {
  type: 'promotion',
  name: 'Promotion',
  icon: ICON_NAME_PROMOTION,
  access: ['PM', 'EM'],
  link: '/promotion',
  isOnMenu: true,
  isOnBannerTable: false
};

export const EventsModuleConfig: ILiveSiteModuleConfig = {
  type: 'events',
  name: 'Events',
  icon: ICON_NAME_EVENTS,
  access: ['PM', 'EM'],
  link: '/events',
  isOnMenu: true,
  isOnBannerTable: false
};

export const OpponentsModuleConfig: ILiveSiteModuleConfig = {
  type: 'opponents',
  name: 'Opponents',
  icon: ICON_NAME_OPPONENTS,
  access: ['PM', 'EM'],
  link: '/participants',
  isOnMenu: true,
  isOnBannerTable: false
};

export const SettingsModuleConfig: ILiveSiteModuleConfigGroup = {
  type: 'settings',
  name: 'Settings',
  icon: ICON_NAME_SETTINGS,
  access: ['PM'],
  link: '',
  children: [
    AccountsManagementModuleConfig,
    {
      type: 'managers',
      name: 'User Management',
      icon: ICON_NAME_MEMBERS,
      access: ['PM'],
      link: '/managers',
      isOnMenu: true,
      isOnBannerTable: false
    },
    {
      type: 'legal',
      name: 'Legal',
      icon: ICON_NAME_LEGAL,
      access: ['PM'],
      link: '/settings',
      isOnMenu: true,
      isOnBannerTable: false
    }
  ],
  isOnMenu: true,
  isOnBannerTable: true
};

export const ShopModuleConfig: ILiveSiteModuleConfigGroup = {
  type: 'shop',
  name: 'Shop',
  icon: ICON_NAME_SHOP,
  access: ['PM', 'EM'],
  link: '',
  isOnMenu: true,
  isOnBannerTable: true,
  children: [
    {
      type: 'shop_admin',
      name: 'Shop Admin',
      icon: ICON_NAME_SHOP,
      access: ['PM', 'EM'],
      link: `https://shop-buetzer-buebe${environment}.${config.baseDomain}/admin`,
      isOnMenu: true,
      isOnBannerTable: false,
      external: true
    },
    {
      type: 'shop_stripe',
      name: 'Shop payments',
      icon: ICON_NAME_SHOP,
      access: ['PM', 'EM'],
      link: '/shop/stripe',
      isOnMenu: true,
      isOnBannerTable: false
    }
  ],
  // external: true
};

export const BannerModuleConfig: ILiveSiteModuleConfig = {
  type: 'banners',
  name: 'Banners',
  icon: ICON_NAME_BANNER,
  access: ['PM', 'EM'],
  link: '/banners',
  isOnMenu: true,
  isOnBannerTable: false
};

export const StreamModuleConfig: ILiveSiteModuleConfig = {
  type: 'stream',
  name: 'Stream',
  icon: ICON_NAME_STREAM,
  access: ['PM', 'EM'],
  link: !config.useFakeStream ? '/stream' : '/stream',
  isOnMenu: true,
  isOnBannerTable: true
};




// WEBPACK FOOTER //
// ./src/reducers/modules-config/modulesConfig.ts